import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Panel, DataTable, DataTableColumn } from "@countysuite/ui";
import { BasePage } from "pages/BasePage";
import {
  RequestLedgerSubCategory,
  RequestLedgerSubCategoriesStore,
} from "pages/SystemSettings/RequestLedgerSubCategoriesPage/requestLedgerSubCategories";
import { AllStores } from "stores/all";

interface Props {
  requestLedgerSubCategories: RequestLedgerSubCategoriesStore;
}

// const RequestCategoryRow: React.FC<any> = (props) => {
//     return <Row>
//         <Col xs={12}>
//             <TextBox name="rc-row" onChange={props.updateCost} />
//         </Col>
//     </Row>
// }

export const RequestLedgerSubCategoriesPage: React.FC<Props> = ({
  requestLedgerSubCategories,
}) => {
  // const postRequestLedgerSubCategory = async (e: any) => {
  //     const res = await Http.post<any>({
  //         url: 'SystemSettings/SaveRequestLedgerSubCategoryData',
  //         data: { dto: requestLedgerSubCategories.selectedSubCategory },
  //         waitMessage: `Saving ${requestLedgerSubCategories.selectedSubCategory.name}, please wait.`
  //     })

  //     if (res.success) {
  //         await fetchRequestLedgerSubCategoryData();
  //         requestLedgerSubCategories.resetSelectedSubCategory();
  //     }
  // }

  useEffect(() => {
    requestLedgerSubCategories.fetchAll();
  }, [requestLedgerSubCategories]);

  const dtColumns: DataTableColumn<RequestLedgerSubCategory>[] = [
    {
      Header: "Name",
      accessor: "name",
      width: 300,
    },
    {
      Header: "Total Costs",
      //TODO: finish
    },
  ];

  return (
    <BasePage>
      <Panel title="Request Ledger Sub Categories">
        <Row>
          <Col xs={12}>
            <h3>TODO: FINISH!</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="full-width">
              <DataTable
                data={requestLedgerSubCategories.all}
                columns={dtColumns}
              />
            </div>
          </Col>
        </Row>
      </Panel>
    </BasePage>
  );
};

function mapStores(stores: AllStores) {
  return { requestLedgerSubCategories: stores.requestLedgerSubCategoriesStore };
}

export default inject(mapStores)(observer(RequestLedgerSubCategoriesPage));
